import React from 'react';
import useInView from '../hooks/useInView';

// Order: as specified — e2open after snowflake, truegradient next, o9 at end
const partners = [
  { id: 'aws',          src: '/Aws-logo.png',        alt: 'Amazon AWS'    },
  { id: 'databricks',   src: '/Databricks-logo.png', alt: 'Databricks'    },
  { id: 'snowflake',    src: '/Snowflake-logo.png',  alt: 'Snowflake'     },
  { id: 'e2open',       src: '/E2open.svg',          alt: 'E2open'        },
  { id: 'doss',         src: '/Doss.svg',            alt: 'Doss'          },
  // { id: 'truegradient', src: '/Truegradient.svg',    alt: 'Truegradient'  },
  { id: 'o9',           src: '/O9-logo.png',         alt: 'o9 Solutions'  },
];

const PartnersSection = () => {
  const [ref, inView] = useInView();

  // Duplicate the array 3× so the marquee loop is seamless with no gaps
  const track = [...partners, ...partners, ...partners];

  return (
    <section
      ref={ref}
      className="relative py-24 overflow-hidden border-y"
      style={{ backgroundColor: '#13161f', borderColor: 'rgba(255,255,255,0.08)' }}
    >
      {/* Edge gradient lines */}
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-blue-accent/20 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-blue-accent/20 to-transparent" />

      {/* Left + right edge fade masks so logos appear/disappear softly */}
      <div
        className="absolute left-0 top-0 bottom-0 w-24 z-10 pointer-events-none"
        style={{ background: 'linear-gradient(to right, #13161f 0%, transparent 100%)' }}
      />
      <div
        className="absolute right-0 top-0 bottom-0 w-24 z-10 pointer-events-none"
        style={{ background: 'linear-gradient(to left, #13161f 0%, transparent 100%)' }}
      />

      {/* Label row */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-12">
        <span
          className="text-s font-body font-semibold tracking-[0.2em] uppercase"
          style={{
            color:      '#8892a4',
            opacity:    inView ? 1 : 0,
            transform:  inView ? 'translateY(0)' : 'translateY(12px)',
            transition: 'all 0.6s ease',
            display:    'block',
            textAlign:  'center',
          }}
        >
          Strategic Partners
        </span>
      </div>

      {/* Scrolling track */}
      <div
        className="relative"
        style={{
          opacity:    inView ? 1 : 0,
          transition: 'opacity 0.8s ease 0.2s',
        }}
      >
        <div
          className="flex items-center partners-marquee"
          style={{ width: 'max-content' }}
        >
          {track.map((p, i) => (
            <div
              key={`${p.id}-${i}`}
              className="group shrink-0 flex items-center justify-center"
              style={{ padding: '0 40px' }}
            >
              <img
                src={p.src}
                alt={p.alt}
                draggable={false}
                className="w-auto object-contain opacity-100 group-hover:opacity-100 transition-all duration-300 group-hover:scale-105"
                style={{
                  height:     'clamp(20px, 2.6vw, 58px)',
                  maxHeight:  '38px',
                  display:    'block',
                }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Keyframe + marquee animation injected inline */}
      <style>{`
        @keyframes marquee-scroll {
          0%   { transform: translateX(0); }
          100% { transform: translateX(calc(-100% / 3)); }
        }

        .partners-marquee {
          animation: marquee-scroll 28s linear infinite;
          will-change: transform;
        }

        /* Pause on hover — desktop only, let mobile scroll freely */
        @media (hover: hover) {
          .partners-marquee:hover {
            animation-play-state: paused;
          }
        }

        /* Slightly faster on small screens so it doesn't feel sluggish */
        @media (max-width: 640px) {
          .partners-marquee {
            animation-duration: 18s;
          }
        }
      `}</style>
    </section>
  );
};

export default PartnersSection;